module.exports = key =>
  key === 'parent' || key === 'store' || key === 'meta' || key === 'className'

// key === 'decorated' ||
// key === 'transformers' ||
// key === 'inspect' ||
